import { ApiBase } from '@/api/api'
import {
  makeDeleteRequest,
  makePostRequest,
  makePutRequest,
} from '@/api/fetchCalls'
import type {
  CreateUpdateStripeIntegrationProps,
  StripeIntegration,
} from '@/types/stripe-integration'

export const addStripeIntegration = async (
  data: CreateUpdateStripeIntegrationProps
): Promise<StripeIntegration> => {
  return (await makePostRequest(`${ApiBase}/stripe/integrations`, {
    body: JSON.stringify(data),
  })) as Promise<StripeIntegration>
}

export const updateStripeIntegration = async (
  id: string,
  data: CreateUpdateStripeIntegrationProps
): Promise<StripeIntegration> => {
  return (await makePutRequest(`${ApiBase}/stripe/integrations/${id}`, {
    body: JSON.stringify(data),
  })) as Promise<StripeIntegration>
}

export const deleteStripeIntegration = async (
  id: string
): Promise<undefined> => {
  return (await makeDeleteRequest(
    `${ApiBase}/stripe/integrations/${id}`
  )) as Promise<undefined>
}
